<template>
  <div style="width: 100%;height: 100%;">
    <div style="width: 95%;margin: 0 auto;">
      <div style="width: 100%;text-align: right;">
        <el-upload
          class="avatar-uploader"
          ref="upload_photo"
          action="/api/updateRQEWM"
          :data="AddForm"
          :auto-upload="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :on-change="changephoto"
          :on-remove="handleRemove"
          :headers="myHeaders"
          :limit="1"
          list-type="picture">
          <el-button type="primary" size="small" :loading="loading" @click="AddLunbo" style="margin-left: 10px;">提交</el-button>
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <div slot="tip" class="el-upload__tip">只能上传图片文件，且不超过3MB，最多上传1个文件 </span></div>
        </el-upload>
      </div>
      <div>
        <hr>
      </div>
      <div style="width: 600px;margin: 0 auto;">
        <img width="600px" :src="photo[0].content" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
export default {
  created() {
    this.Atoken=sessionStorage.getItem("Atoken");
    this.AddForm.admin_id=this.$store.state.a_id;
  },
  data () {
    return {
      photo:'',
      loading: false,
      myHeaders: {
        Atoken:'',
      },
      AddForm:{
        admin_id:'',
      },
      //管理员相关信息
      AdminInfor:{
        id:'',
        name:'',
        photo:'',
        type:'',
      },
    }
  },
  //页面开启时执行
  mounted(){
    this.getData()
  },
  //方法
  methods: {
    getData() {
      this.loading = true,
      commonAPI('queryRQEWM','1').then(res => {
        this.loading = false;
        this.photo = res.data.data.rows;
        //console.log(res.data.rows);
      })
    },
    //添加内容
    AddLunbo(){
      this.AddForm.admin_id=this.$store.state.a_id;
      this.$refs.upload_photo.submit();
    },

    //获取信息方法
    judgeLogin(){
      this.AdminInfor.id=this.$store.state.a_id;
    },

    //修改图片成功
    handleAvatarSuccess(res, file) {
      if(this.response.response(res)){
        this.getData();
      }
    },
    //删除当前文件
    handleRemove(file, fileList) {
      //console.log(file, fileList);
      this.imageUrl = '';
    },
    //改变图片框状态
    changephoto(file, fileList){
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log(file);
    },
    beforeAvatarUpload(file) {
      let types = ['image/jpeg', 'image/gif', 'image/bmp', 'image/png'];
      const isImage = types.includes(file.type);
      const isLtSize = file.size / 1024 / 1024 < 3;
      if (!isImage) {
      this.$message.error('上传图片只能是 JPG、GIF、BMP、PNG 格式!');
      }
      if (!isLtSize) {
      this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isImage && isLtSize;
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/admin/views/NMRQEWM/RQEWMSC.vue